import api from 'src/config/api';
import {
	IGetQuestionnaireTemplatesRequestParams,
	IQuestionnaireTemplateRequest,
	IQuestionnaireTemplateResponse,
	IQuestionnaireTemplate,
} from 'src/features/questionnaire_template/domain/types';

export const questionnnaireTemplateApi = {
	createQuestionnaireTemplate: async (
		questionnaireTemplateData: IQuestionnaireTemplateRequest,
		siteSlug: string,
	): Promise<IQuestionnaireTemplateResponse> => {
		const response = await api.post(
			'/api/v1/questionnaire-template',
			questionnaireTemplateData,
			{
				headers: {
					Site: siteSlug,
				},
			},
		);
		return response.data;
	},

	getQuestionnaireTemplate: async (
		questionnaireTemplateId: number,
		siteSlug: string,
	): Promise<IQuestionnaireTemplateResponse> => {
		const response = await api.get(
			`/api/v1/questionnaire-template/${questionnaireTemplateId}`,
			{
				headers: {
					Site: siteSlug,
				},
			},
		);
		return response.data;
	},

	getQuestionnaireTemplates: async (
		requestParams: IGetQuestionnaireTemplatesRequestParams,
		siteSlug: string,
	): Promise<IQuestionnaireTemplate[]> => {
		const { sort, order, only_published } = requestParams;

		const params = new URLSearchParams({
			...(sort && order && { sort, order }),
			...(only_published !== undefined && {
				only_published: String(only_published),
			}),
		});

		const response = await api.get(
			`/api/v1/questionnaire-templates?${params}`,
			{
				headers: {
					Site: siteSlug,
				},
			},
		);
		return response.data;
	},

	deleteQuestionnaireTemplate: async (
		questionnaireTemplateId: number,
		siteSlug: string,
	): Promise<void> => {
		await api.delete(
			`/api/v1/questionnaire-template/${questionnaireTemplateId}`,
			{
				headers: { Site: siteSlug },
			},
		);
		return;
	},
};
